import {Component, OnInit, ViewChild} from '@angular/core';
import {map, switchMap, takeUntil, toArray} from "rxjs/operators";
import {TaskService} from "../../services/task.service";
import {DataTableComponent, PaginationModel} from "@alfresco/adf-core";
import {FormGroup} from "@angular/forms";
import {MatDialog} from '@angular/material/dialog';
import {FormTaskDialogComponent} from "../form-task-dialog/form-task-dialog";
import {TraductionPipe} from "../../pipes/traduction.pipe";
import {ContentActionRef} from "@alfresco/adf-extensions";
import {from, Observable, Subject} from "rxjs";
import {FormProcessusDialogComponent} from "../form-processus-dialog/form-processus-dialog.component";
import {PageEvent} from "@angular/material/paginator";
// @ts-ignore
import { AppService } from '../../../../../aca-shared/src/lib/services/app.service';
import {ActivatedRoute} from "@angular/router";

@Component({
  standalone: false,
  selector: 'my-tasks',
  templateUrl: './my-tasks.html',
  styleUrls: ['../../ui/workflow-page.scss'],
})
export class MyTasksComponent implements OnInit {
  @ViewChild(DataTableComponent, {static: true}) dataTable: DataTableComponent;
  appNavNarMode$: Observable<'collapsed' | 'expanded'>;

  tasks$;
  schema: any;
  pagination: PaginationModel;
  form: FormGroup;
  searchTerm: any;
  actions: Array<ContentActionRef> = [];
  onDestroy$: Subject<boolean> = new Subject<boolean>();
  isValidPath = true;
  limit: number = 15;
  offset: number = 0;
  showAll: any;
  currentPage: number = 0;
  private showEnCours: boolean = true;

  constructor(private taskService: TaskService, public dialog: MatDialog, private appService: AppService, private route: ActivatedRoute) {
    this.appNavNarMode$ = appService.appNavNarMode$.pipe(takeUntil(this.onDestroy$));
  }

  ngOnInit() {
    this.initTasks();
    this.route.queryParams.subscribe(params => {
      if (params?.task_id) {
        this.openTaskByID(params.task_id);
        this.dialog.afterAllClosed.subscribe(() => {
          this.initTasks();
        });
      }
    });
  }

  trackByActionId(_: number, action: ContentActionRef) {
    return action.id;
  }

  initTasks(en_cours: boolean = true) {
    this.pagination = new PaginationModel({
      pageSize: this.limit
    });
    this.tasks$ = this.taskService.getTasksForCurrentUser(en_cours, null, this.offset, this.limit).pipe(
      switchMap((response: any) => {
        const pagination = response.list.pagination;
        this.pagination.totalItems = pagination.totalItems;
        return from(response.list.entries || []);
      }),
      map((entry: any) => entry.entry),
      map((task: any) => {
        task.state = task.state ? new TraductionPipe().transform(task.state) : '';
        return task;
      }),
      toArray()
    );
    this.schema = [
      {type: 'text', key: 'id', title: 'ID', sortable: true},
      {type: 'text', key: 'name', title: 'Nom', sortable: true},
      {type: 'text', key: 'assignee', title: 'Assigné à', sortable: true},
      {type: 'text', key: 'priority', title: 'Priorité', sortable: true},
      {type: 'text', key: 'state', title: 'Statut', sortable: true},
      // {type: 'text', key: 'actions', title: 'Actions', sortable: false, srTitle: 'Actions', cssClass: 'adf-datatable-content-action-column'}
    ];
  }

  openTaskByID(id: string) {
    this.taskService.getById(id).subscribe((response: any) => {
      this.dialog.open(FormTaskDialogComponent, {
        maxWidth: '1000px',
        width: '100%',
        minHeight: '400px',
        data: {obj: response?.entry}
      })
    })
  }

  onPaginationChanged(pagination: PaginationModel) {
    this.pagination = pagination;
  }

  onRowClick(event: any) {
    if (this.showEnCours) {
      this.dialog.open(FormTaskDialogComponent, {
        maxWidth: '1000px',
        width: '100%',
        minHeight: '400px',
        data: event
      })
    } else {
      alert("Vous ne pouvez pas modifier une tâche terminée")
    }
    this.dialog.afterAllClosed.subscribe(() => {
      this.initTasks(this.showEnCours);
    });
  }

  onSearchTermChange($event: any) {
    this.searchTerm = typeof $event === 'string' ? $event : $event?.target?.value;
    this.offset = 0;
    this.tasks$ = this.taskService.getTasksForCurrentUser(this.showEnCours, this.searchTerm, 0, this.limit).pipe(map((response: any) => {
      this.pagination.totalItems = response?.list?.pagination?.totalItems || 0;
      return response?.list?.entries?.map(entry => entry.entry) || [];
    }));
  }

  nouveauProcessus() {
    // Je dois ouvrir le mat dialog et injecter le new processus component
    this.dialog.open(FormProcessusDialogComponent, {
      width: '1440px',
    })
  }

  onPageChange($event: PageEvent) {
    this.offset = $event.pageIndex * $event.pageSize;
    this.limit = $event.pageSize;
    this.currentPage = $event.pageIndex;
    this.initTasks(this.showEnCours);
  }

  showTasksFinished() {
    this.showEnCours = !this.showEnCours;
    this.offset = 0;
    this.limit = 15;
    this.currentPage = 0;
    this.initTasks(this.showEnCours);

  }

  toggleClick() {
    this.appService.toggleAppNavBar$.next();
  }

  copyLink(row: any) {
    let start = location.href.includes('localhost') ? '/#' : '/aca/#';
    let url = window.location.origin + start + '/my-tasks?task_id=' + row.id;
    navigator.clipboard.writeText(url).then(() => {
      alert("Lien copié dans le presse-papier")
    });
  }
}
